import { useState } from 'react';
import Selector from '../../../components/Selector';
import { AestheticsServices } from '../../../screens/ModalBudget/components/TabsContent/AestheticsServices';
import { BodyshopServices } from '../../../screens/ModalBudget/components/TabsContent/BodyshopServices';
import { Parts } from '../../../screens/ModalBudget/components/TabsContent/Parts';
import { Tables } from '../../../screens/ModalBudget/components/TabsContent/Tables';
import { TotalBudget } from '../../../screens/ModalBudget/components/TotalBudget';
import { BUDGET_TABS } from '../../../screens/ModalBudget/utils/enum';
import { ActionsButtonOS } from './ActionsButtonOS.jsx';
import { OSDetails } from './OSDetails.jsx';
import { OSEntryChecklist } from './OSEntryChecklist.jsx';
import { OSImportBudget } from './OSImportBudget.jsx';
import { OSNotes } from './OSNotes.jsx';

export const OSBudgetTabs = (props) => {
  const {
    budget,
    showBudgetItems,
    onChange,
    client,
    clientLoading,
    values,
    setOpen,
    vehicle,
    vehicleLoading,
    company,
    isFullscreen,
    isntLinearHour,
    hvTable,
    setIsntLinearHour,
    bodyshopService,
    setBodyshopService,
    setBodyshopServiceVersion,
    onRemoveService,
    changeValue,
    onRemovePiece,
    changePartsValue,
    openEditModal,
    parts,
    setParts,
    isOpen,
    onRemoveAeService,
    aeService,
    setAeService,
    compareValues,
    sendWhatsapp,
    toShare,
    isLoading,
    onRemove,
    onSave,
    totalParts,
    totalSum,
    totalBodyshopService,
    totalAeService,
    changeValueAeService,
    reloadPrint,
    printCompany,
    setCurrentClientId,
    setCurrentVehicleId,
    setValues,
    setSetHasCreatedConsultant,
    setReloadPrint,
    setOldValues,
    setHasCreated,
    setHasCreatedTypeOS,
    reloadConsultants,
    reloadTypeOS,
    isNew,
    setClientCreationContext,
  } = props;

  const [consultantState, setConsultantState] = useState(null);
  const [localSignatureData, setLocalSignatureData] = useState(null);
  const [isSignatureReset, setIsSignatureReset] = useState(false);

  // Função para salvar a OS antes da assinatura e retornar o ID
  const handleSaveBeforeSignature = async () => {
    if (values?.id) {
      // Se já tem ID, não precisa salvar novamente
      return values.id;
    }

    try {
      // Para OS nova, precisamos salvar sem redirecionar
      // A flag skipRedirect=true faz com que não redirecione após salvar
      const savedId = await onSave(undefined, true);

      if (savedId) {
        return savedId;
      }

      return null;
    } catch (error) {
      console.error('Erro ao salvar antes da assinatura:', error);
      return null;
    }
  };

  return (
    <div className="modal-content-wrapper">
      <div className="main-content-modal1">
        <div style={{ textAlign: 'center' }}>
          {isFullscreen ? (
            budget === BUDGET_TABS.DETAILS ? (
              <div className="full-screen-tabs-container">
                <Selector
                  handleClick={() => showBudgetItems(1)}
                  buttonClass={budget === 1 ? 'highlighted' : ''}
                  id={'Detalhes'}
                  name={'Detalhes'}
                />
                <Selector
                  handleClick={() => showBudgetItems(4)}
                  buttonClass={budget === 4 ? 'highlighted' : ''}
                  id={'Tabelas'}
                  name={'Tabelas'}
                />
              </div>
            ) : null
          ) : (
            <div className="modal-budget-nav-tabs-container">
              <Selector
                handleClick={() => showBudgetItems(BUDGET_TABS.DETAILS)}
                buttonClass={
                  budget === BUDGET_TABS.DETAILS ? 'highlighted' : ''
                }
                id={'Detalhes'}
                name={'Detalhes'}
              />
              <Selector
                handleClick={() => showBudgetItems(BUDGET_TABS.NOTES)}
                buttonClass={budget === BUDGET_TABS.NOTES ? 'highlighted' : ''}
                id={'Anotações'}
                name={'Anotações'}
              />
              <Selector
                handleClick={() => showBudgetItems(BUDGET_TABS.ENTRY_CHECKLIST)}
                buttonClass={
                  budget === BUDGET_TABS.ENTRY_CHECKLIST ? 'highlighted' : ''
                }
                id={'LaudoTermo'}
                name={'Laudo/Termo'}
              />
              <Selector
                handleClick={() => showBudgetItems(BUDGET_TABS.BODYSHOP)}
                buttonClass={
                  budget === BUDGET_TABS.BODYSHOP ? 'highlighted' : ''
                }
                id={'ServiçosFunilaria'}
                name={'Serviços Funilaria e Pintura'}
              />
              <Selector
                handleClick={() => showBudgetItems(BUDGET_TABS.AESTHETICS)}
                buttonClass={
                  budget === BUDGET_TABS.AESTHETICS ? 'highlighted' : ''
                }
                id={'ServiçosEstetica'}
                name={'Serviços'}
              />
              <Selector
                handleClick={() => showBudgetItems(BUDGET_TABS.PARTS)}
                buttonClass={`${
                  budget === BUDGET_TABS.PARTS ? 'highlighted' : ''
                }`}
                id={'Peças'}
                name={'Peças'}
              />

              <Selector
                handleClick={() => showBudgetItems(BUDGET_TABS.IMPORT_BUDGET)}
                buttonClass={`${
                  budget === BUDGET_TABS.IMPORT_BUDGET ? 'highlighted' : ''
                }`}
                id={'Importar orçamento'}
                name={'Importar orçamento'}
              />
            </div>
          )}
        </div>

        <OSDetails
          setHasCreatedTypeOS={setHasCreatedTypeOS}
          setHasCreated={setHasCreated}
          reloadPrint={reloadPrint}
          setOldValues={setOldValues}
          setReloadPrint={setReloadPrint}
          setSetHasCreatedConsultant={setSetHasCreatedConsultant}
          setValues={setValues}
          budget={budget}
          onChange={onChange}
          client={client}
          clientLoading={clientLoading}
          values={values}
          setOpen={setOpen}
          vehicle={vehicle}
          vehicleLoading={vehicleLoading}
          company={company}
          setCurrentClientId={setCurrentClientId}
          setCurrentVehicleId={setCurrentVehicleId}
          reloadConsultants={reloadConsultants}
          reloadTypeOS={reloadTypeOS}
          setConsultantState={setConsultantState}
          setClientCreationContext={setClientCreationContext}
        />

        <OSNotes
          budget={budget}
          onChange={onChange}
          values={values}
          company={company}
          printCompany={printCompany}
        />

        <OSEntryChecklist
          company={company}
          printCompany={printCompany}
          budget={budget}
          onChange={onChange}
          values={values}
          localSignatureData={localSignatureData}
          setLocalSignatureData={setLocalSignatureData}
          isSignatureReset={isSignatureReset}
          setIsSignatureReset={setIsSignatureReset}
          onSaveBeforeSignature={handleSaveBeforeSignature}
        />

        <BodyshopServices
          budget={budget}
          values={values}
          onChange={onChange}
          isntLinearHour={isntLinearHour}
          hvTable={hvTable}
          setIsntLinearHour={setIsntLinearHour}
          setOpen={setOpen}
          bodyshopService={bodyshopService}
          onRemoveService={onRemoveService}
          changeValue={changeValue}
        />
        <Parts
          budget={budget}
          isOpen={isOpen}
          setOpen={setOpen}
          onRemovePiece={onRemovePiece}
          changePartsValue={changePartsValue}
          openEditModal={openEditModal}
          parts={parts}
        />
        <Tables
          budget={budget}
          showBudgetItems={showBudgetItems}
          isOpen={isOpen}
          setOpen={setOpen}
          onRemovePiece={onRemovePiece}
          changePartsValue={changePartsValue}
          openEditModal={openEditModal}
          parts={parts}
          values={values}
          onChange={onChange}
          setIsntLinearHour={setIsntLinearHour}
          isntLinearHour={isntLinearHour}
          hvTable={hvTable}
          onRemoveService={onRemoveService}
          changeValue={changeValue}
          bodyshopService={bodyshopService}
          onRemoveAeService={onRemoveAeService}
          aeService={aeService}
        />
        <AestheticsServices
          budget={budget}
          setOpen={setOpen}
          onRemoveAeService={onRemoveAeService}
          values={values}
          changeValueAeService={changeValueAeService}
          aeService={aeService}
        />

        <OSImportBudget
          values={values}
          onImport={(budgetData) => {
            if (budgetData.bodyshopServices?.length > 0) {
              setBodyshopService((prev) => [
                ...prev,
                ...budgetData.bodyshopServices,
              ]);
              setBodyshopServiceVersion((v) => v + 1);
            }

            if (budgetData.aeServices?.length > 0) {
              setAeService((prev) => [...prev, ...budgetData.aeServices]);
            }

            if (budgetData.parts?.length > 0) {
              setParts((prev) => [...prev, ...budgetData.parts]);
            }

            if (
              budgetData.details &&
              Object.keys(budgetData.details).length > 0
            ) {
              setValues((prev) => ({
                ...prev,
                ...budgetData.details,
              }));
            }

            // Sincroniza o toggle hora linear/tabela com o vindo do orçamento
            if (budgetData.details?.hour !== undefined) {
              setIsntLinearHour(budgetData.details.hour);
            }

            if (budgetData.newlyImportedBudgets?.length > 0) {
              setValues((prev) => ({
                ...prev,
                newlyImportedBudgets: [
                  ...(prev.newlyImportedBudgets || []),
                  ...budgetData.newlyImportedBudgets,
                ],
              }));
            }

            setReloadPrint((prev) => !prev);
          }}
          budget={budget}
          company={company}
        />

        <TotalBudget
          budget={budget}
          totalParts={totalParts}
          totalSum={totalSum}
          totalBodyshopService={totalBodyshopService}
          totalAeService={totalAeService}
          values={values}
          onChange={onChange}
        />

        <ActionsButtonOS
          budget={budget}
          consultantState={consultantState}
          reloadPrint={reloadPrint}
          compareValues={compareValues}
          sendWhatsapp={sendWhatsapp}
          toShare={toShare}
          isLoading={isLoading}
          values={values}
          onRemove={onRemove}
          onSave={onSave}
          printCompany={printCompany}
          client={client}
          totalSum={totalSum}
          totalBodyshopService={totalBodyshopService}
          totalParts={totalParts}
          totalAeService={totalAeService}
          bodyshopService={bodyshopService}
          aeService={aeService}
          parts={parts}
          observation={values.observation_os ?? company.serviceOrderNote}
          localSignatureData={localSignatureData}
        />
      </div>
    </div>
  );
};
